import { createRoot } from 'react-dom/client';
import { loadScript, collectError } from 'utils';
import { APP_BUNDLES_PATHS } from 'consts';

import { i18n } from './core/utils/i18n';
import Root from './core';

import 'assets/fonts/fonts.css';

i18n()
    .then(() => {
        console.log(`${import.meta.env.VITE_APP_NAME} commit hash = `, __COMMIT_HASH__);

        const container = document.getElementById('app');
        const root = createRoot(container!);

        root.render(<Root />);
        pendo.initialize({
            disableGuides: true,
        });

        void loadScript(APP_BUNDLES_PATHS.MFA, true);
    })
    .catch(collectError); // NOSONAR
